import { render, staticRenderFns } from "./ShowSelections.vue?vue&type=template&id=5a44d6cf&"
import script from "./ShowSelections.vue?vue&type=script&lang=js&"
export * from "./ShowSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports